"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyToEthInfoRetriever = void 0;
const any_to_any_proxy_1 = require("./any-to-any-proxy");
/**
 * Retrieves a list of payment events from a payment reference, a destination address and a proxy contract
 */
class AnyToEthInfoRetriever extends any_to_any_proxy_1.ConversionInfoRetriever {
    getFeeFilter() {
        // Create a filter to find all the Fee Transfer logs with the payment reference
        const feeFilter = this.contractConversionProxy.filters.TransferWithReferenceAndFee(null, null, '0x' + this.paymentReference);
        feeFilter.fromBlock = this.conversionProxyCreationBlockNumber;
        feeFilter.toBlock = 'latest';
        return feeFilter;
    }
}
exports.AnyToEthInfoRetriever = AnyToEthInfoRetriever;
